import { Grid } from '@mui/material';
import React from 'react';
import SearchBar from '../../components/form/SearchBar';
import { useStore } from '../../stores/store';

type NotificationLogsToolbarProps = {};

const NotificationLogsToolbar: React.FC<NotificationLogsToolbarProps> = () => {
    const { notificationLogStore } = useStore();

    const handleSearch = (query: string) => {
        notificationLogStore.search = query;
    }

    return (
        <Grid container>
            <Grid item xs={9} sm={4} lg={3} marginBottom={3} >
                <SearchBar onSearch={handleSearch} isRounded={false} placeholder="SEARCH_BY_RECIPIENTS_FULL_NAME_TARGET_OR_TEMPLATE_NAME" />
            </Grid>
        </ Grid>
    );
};

export default NotificationLogsToolbar;